import NavigationRouter from './navigation';

export default NavigationRouter;
